<div class="container">
    <h5 class="text-center"> Partie fini vous avez {{ point }}/{{ total }}</h5>
    <div class="row w-50 mx-auto text-center">
        <button class="btn-cat mx-auto btn-next" (click)="Menu()"> 🚪 Revenir au menu </button>
        <button class="btn-cat mx-auto btn-next" (click)="Recommencer()"> 🔁 Recommencer cet partie </button>
    </div>
</div>
